import { SelectableClient } from './selectable-client';

export class UserInfo {
  public UserId: number;
  public UserName: string;
  public UserEmail: string;
  public UserFullName: string;
  public ApplicationId: number;
  public HasClientSelection: boolean;
  public ClientId: number;
  public ClientCode: string;
  public ClientName: string;
  public HasRoleSelection: boolean;
  public HasCustomerSelection: boolean;
  public HasGodMode: boolean;
  public HasManageUsers: boolean;
  public HasCustomGridEditor: boolean;
  public HasClientCustomGridsEditor: boolean;
  public HasGeographyFullAccess: boolean;
  public HasSalesRepRole: boolean;
  public Lang: string;
  public HasDownloads: boolean;
  public SelectableClients: Array<SelectableClient> = [];

  constructor(userinfo: any) {
    this.UserId = userinfo.userId;
    this.UserName = userinfo.userName;
    this.UserEmail = userinfo.userEmail;
    this.UserFullName = userinfo.userFullName;
    this.ApplicationId = userinfo.applicationId;
    this.HasClientSelection = userinfo.HasClientSelection;
    this.ClientId = userinfo.ClientId;
    this.ClientCode = userinfo.ClientCode;
    this.ClientName = userinfo.ClientName;
    this.HasRoleSelection = userinfo.HasRoleSelection;
    this.HasCustomerSelection = userinfo.HasCustomerSelection;
    this.HasGodMode = userinfo.HasGodMode;
    this.HasManageUsers = userinfo.HasManageUsers;
    this.HasCustomGridEditor = userinfo.HasCustomGridEditor;
    this.HasClientCustomGridsEditor = userinfo.HasClientCustomGridsEditor;
    this.HasGeographyFullAccess = userinfo.HasGeographyFullAccess;
    this.HasSalesRepRole = userinfo.HasSalesRepRole;
    this.SelectableClients = userinfo.SelectableClients;
    this.Lang = '';
    this.HasDownloads = false;
  }
}
